export const removeLocalStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("userType");
  localStorage.removeItem("userName");
  localStorage.removeItem("email");
}